import * as types from "./actionType";

const initialState = {
  pieChartStatistics: null,
  fetchingPieChartStatistics: false,
  customerStatistics: null,
  fetchingCustomerStatistics: false,
  eventsStatistics: null,
  fetchingEventsStatistics: false,
  ridesStatistics: null,
  fetchingRidesStatistics: false,
};

function statisticsReducer(state = initialState, action) {
  switch (action.type) {
    case types.PIE_CHART_STATISTICS:
      return {
        ...state,
        pieChartStatistics: null,
        fetchingPieChartStatistics: false,
      };
    case types.PIE_CHART_STATISTICS_SUCCESS:
      return {
        ...state,
        pieChartStatistics: action.payload,
        fetchingPieChartStatistics: true,
      };
    case types.PIE_CHART_STATISTICS_FAILED:
      return {
        ...state,
        barGraphStatistics: null,
        fetchingbarGraphStatistics: false,
      };
    case types.CUSTOMER_STATISTICS:
      return {
        ...state,
        customerStatistics: null,
        fetchingCustomerStatistics: false,
      };
    case types.CUSTOMER_STATISTICS_SUCCESS:
      return {
        ...state,
        customerStatistics: action.payload,
        fetchingCustomerStatistics: true,
      };
    case types.CUSTOMER_STATISTICS_FAILED:
      return {
        ...state,
        customerStatistics: null,
        fetchingCustomerStatistics: false,
      };
    case types.EVENTS_STATISTICS:
      return {
        ...state,
        eventsStatistics: null,
        fetchingEventsStatistics: false,
      };
    case types.EVENTS_STATISTICS_SUCCESS:
      return {
        ...state,
        eventsStatistics: action.payload,
        fetchingEventsStatistics: true,
      };
    case types.EVENTS_STATISTICS_FAILED:
      return {
        ...state,
        eventsStatistics: null,
        fetchingEventsStatistics: false,
      };
    case types.RIDES_STATISTICS:
      return {
        ...state,
        ridesStatistics: null,
        fetchingRidesStatistics: false,
      };
    case types.RIDES_STATISTICS_SUCCESS:
      return {
        ...state,
        ridesStatistics: action.payload,
        fetchingRidesStatistics: true,
      };
    case types.RIDES_STATISTICS_FAILED:
      return {
        ...state,
        ridesStatistics: null,
        fetchingRidesStatistics: false,
      };
    default:
      return state;
  }
}

export default statisticsReducer;
